import OrdersList from "./OrdersList";

export default function DashboardHome() {
  return <OrdersList heading="Dashboard" subtitle="Your purchased services. Open one to upload files and track progress." />;
}
